export enum DashboardPaymentActiveViewEnum {
  CART_LIST = "cart-list",
  HISTORY = "history",
  SERVICES = "services",
}

export enum DashboardServiceActiveViewEnum {
  TEMPLATES = "templates",
  RECURRING_PAYMENTS = "recurring-payments",
}
